import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { actions } from 'src/features/actionButtons/ActionButtonsSlice'
import styles from './ReportButtons.module.sass'
import Button from '@mui/material/Button'
import usePiwik from 'src/hooks/usePiwik'

const HasAccess = ({ reportSettings, articleId }) => {
  const dispatch = useDispatch()
  const { handleTrackingWithArticleIdProp } = usePiwik()

  const handleDownloadClick = () => {
    dispatch(
      actions.reportDownloadRequest({
        productCode: reportSettings?.productCode,
        reportTitle: reportSettings?.reportTitle
      })
    )
    handleTrackingWithArticleIdProp(
      `article`,
      'button-click',
      'download-now',
      articleId
    )
  }

  return (
    <Button
      className={styles.contactButton}
      variant="contained"
      onClick={handleDownloadClick}
    >
      Download now
    </Button>
  )
}

HasAccess.propTypes = {
  reportSettings: PropTypes.object,
  articleId: PropTypes.any
}

export default HasAccess
